import {ICheckoutData} from "../CheckoutData";
import {
  CheckoutRequestHandler,
  ICheckoutPutParams,
  IPaymentTransaction,
} from "../requestHandlers/CheckoutRequestHandler";
import {IPaymentData} from "./PaymentData";
import {IRequestResponse} from "../../requestHandler/IRequestResponse";

export class PaymentFactory {
  /**
   * Get available payment methods.
   * @param {number} shopId
   * @param {string} checkoutId
   * @returns {Promise<IPaymentData[]>}
   */
  public static async getPaymentMethods(shopId: number, checkoutId: string): Promise<IPaymentData[]> {
    return CheckoutRequestHandler.getPayments(shopId, checkoutId);
  }

  /**
   * Sets the give payment method.
   * @param {number} shopId
   * @param {string} checkoutId
   * @param {ICheckoutPutParams} payload
   * @returns {Promise<ICheckoutData>}
   */
  public static async setPaymentMethod(
    shopId: number,
    checkoutId: string,
    payload: ICheckoutPutParams,
  ): Promise<ICheckoutData> {
    return CheckoutRequestHandler.putParams(shopId, checkoutId, payload);
  }

  /**
   * Initializes payment for the given checkout.
   * @param {string} shopId
   * @param {string} checkoutId
   * @param amazonPayOrderReferenceId
   * @returns {Promise<IPaymentTransaction>}
   */
  public static async initPayment(
    shopId: string,
    checkoutId: string,
    amazonPayOrderReferenceId?: string,
  ): Promise<IPaymentTransaction> {
    return CheckoutRequestHandler.initializePayment(shopId, checkoutId, amazonPayOrderReferenceId);
  }

  /**
   * Returns a token for usage with braintree payment API.
   * @returns {Promise<{clientToken: string}>}
   */
  public static async getBraintreeToken(currencyCode: string): Promise<{clientToken: string}> {
    return CheckoutRequestHandler.getBraintreeToken(currencyCode);
  }

  public static async getFrcVerify(token: string, sitekey: string, visitorId: string): Promise<IRequestResponse> {
    return CheckoutRequestHandler.getFrcVerify(token, sitekey, visitorId);
  }

  /**
   * Authorizes a payment for execution.
   * @param {string} paymentTransactionId
   * @param {string} visitorId
   * @param braintreeNonce
   * @returns {Promise<IPaymentTransaction>}
   */
  public static async authorizePayment(
    paymentTransactionId: string,
    visitorId: string,
    braintreeNonce?: string,
  ): Promise<IPaymentTransaction> {
    return CheckoutRequestHandler.authorizePayment(paymentTransactionId, visitorId, braintreeNonce);
  }
}
